import React from 'react';
import { HostedFieldsProps, TranzilaModalType } from './types';
import { CardInfoModal } from './CardInfo';
import { ProcessingModal } from './ProcessingModal';
import { Method } from './Method';


export const HostedFieldsModal: React.FC<HostedFieldsProps> = ({
  modalState,
  handshakeState,
  toggleModal,
  onPaymentSubmit,
  fieldsErrorState,
  isGoogleEnable,
  setModal,
}) => {
  if (!modalState) return null;

  let modal;
  switch (modalState.modalType) {
    case TranzilaModalType.Loading:
    case TranzilaModalType.Initiation:
    case TranzilaModalType.CardInitiation:
    case TranzilaModalType.MethodInitiation:
      modal = <ProcessingModal stateType={modalState.modalType} />;
      break;
    case TranzilaModalType.Processing:
    case TranzilaModalType.Paying:
      modal = <ProcessingModal stateType={modalState.modalType} />;
      break;
    case TranzilaModalType.CardInfo:
      modal = (
        <CardInfoModal
          toggleModal={toggleModal}
          onPaymentSubmit={onPaymentSubmit}
          handshakeState={handshakeState}
          fieldsErrorState={fieldsErrorState}
          setModal={setModal}
          modalState={modalState}
        />
      );
      break;
    case TranzilaModalType.Method:
      modal = (
        <Method
          toggleModal={toggleModal}
          onPaymentSubmit={onPaymentSubmit}
          handshakeState={handshakeState}
          isGoogleEnable={isGoogleEnable || true}
          setModal={setModal}
          modalState={modalState}
        />
      );
      break;
    default:
      modal = null;
  }

  return modal;
};
